import { ApiFunc, getInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const demoLessonEvaluationList: ApiFunc<`${typeof API.DEMO_LESSON_EVALUATION}`, 'get'> = data =>
  instance.get(API.DEMO_LESSON_EVALUATION, { params: data })

export const demoLessonEvaluationCreate: ApiFunc<`${typeof API.DEMO_LESSON_EVALUATION}`, 'post'> = data =>
  instance.post(API.DEMO_LESSON_EVALUATION, data)

export const demoLessonEvaluationPrincipal: ApiFunc<`${typeof API.DEMO_LESSON_EVALUATION_PRINCIPAL}`, 'get'> = data =>
  instance.get(API.DEMO_LESSON_EVALUATION_PRINCIPAL, { params: data })

export const demoLessonEvaluationCategory: ApiFunc<`${typeof API.DEMO_LESSON_EVALUATION_CATEGORY}`, 'get'> = data =>
  instance.get(API.DEMO_LESSON_EVALUATION_CATEGORY, { params: data })

export const demoLessonEvaluationAssigned: ApiFunc<`${typeof API.DEMO_LESSON_EVALUATION_ASSIGNED}`, 'get'> = data =>
  instance.get(API.DEMO_LESSON_EVALUATION_ASSIGNED, { params: data })

export const demoLessonEvaluationResponseCreate: ApiFunc<
  `${typeof API.DEMO_LESSON_EVALUATION_RESPONSE}`,
  'post'
> = data => instance.post(API.DEMO_LESSON_EVALUATION_RESPONSE, data)

export const demoLessonEvaluationResponseAll: ApiFunc<
  `${typeof API.DEMO_LESSON_EVALUATION_RESPONSE_ALL}`,
  'get'
> = data => instance.get(API.DEMO_LESSON_EVALUATION_RESPONSE_ALL, { params: data })

export const demoLessonCourseCreate: ApiFunc<`${typeof API.DEMO_LESSON_COURSE}`, 'post'> = data =>
  instance.post(API.DEMO_LESSON_COURSE, data)

export const demoLessonCourseDelete: ApiFunc<`${typeof API.DEMO_LESSON_COURSE}{id}`, 'delete'> = data =>
  instance.delete(`${API.DEMO_LESSON_COURSE}${'id' in data ? prop('id', data) : data?.name}`)

export const demoLessonCourseList: ApiFunc<`${typeof API.DEMO_LESSON_COURSE}`, 'get'> = data =>
  instance.get(API.DEMO_LESSON_COURSE, {
    params: data,
  })

export const demoLessonCourseAll: ApiFunc<`${typeof API.DEMO_LESSON_COURSE_ALL}`, 'get'> = data =>
  instance.get(API.DEMO_LESSON_COURSE_ALL, {
    params: data,
  })

export const demoLessonModuleCreate: ApiFunc<`${typeof API.DEMO_LESSON_MODULE}`, 'post'> = data =>
  instance.post(API.DEMO_LESSON_MODULE, data)

export const demoLessonModuleDelete: ApiFunc<`${typeof API.DEMO_LESSON_MODULE}{id}`, 'delete'> = data =>
  instance.delete(`${API.DEMO_LESSON_MODULE}${'id' in data ? prop('id', data) : data?.name}`)

export const demoLessonModuleList: ApiFunc<`${typeof API.DEMO_LESSON_MODULE}`, 'get'> = data =>
  instance.get(API.DEMO_LESSON_MODULE, {
    params: data,
  })

export const demoLessonModuleAll: ApiFunc<`${typeof API.DEMO_LESSON_MODULE_ALL}`, 'get'> = data =>
  instance.get(API.DEMO_LESSON_MODULE_ALL, {
    params: data,
  })

export const demoLessonEvaluationReport: ApiFunc<`${typeof API.DEMO_LESSON_EVALUATION_REPORT}{id}`, 'get'> = data =>
  instance.get(`${API.DEMO_LESSON_EVALUATION_REPORT}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })
